import { useContext } from 'react';
import styles from './ButtonCheckin.style';
import CustomIcon from '../CustomIcon/CustomIcon';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';

export default function ButtonCheckin(props) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const { state: theme } = useContext(ThemeContext);
  const { className: themeClassName, styles: themeStyle } = styles(theme);

  const guestCount =
    (parseInt(props.childrenNumber, 10) || 0) + (parseInt(props.adultsNumber, 10) || 0);

  const { icon = 'hotel1', name, onClick, finished, type } = props;
  const processType = localStorage.getItem('process-type');

  let text =
    props.text || (processType === 'checkin' ? translate('checkIn') : translate('checkOut'));
  if (props.reviewAdvice) text = translate('bookingList.reviewData');
  if (finished) text = translate('ok');

  return (
    <div
      className={`${themeClassName} button-checkin-box ${finished ? '' : 'active'}`}
      onClick={finished && type !== 'rooms' ? () => {} : onClick}
    >
      {guestCount > 0 && <div className={`${themeClassName} guests-count`}>{'x' + guestCount}</div>}
      <div className={`${themeClassName} icon-container`}>
        <CustomIcon type={icon}></CustomIcon>
      </div>
      <div className={`${themeClassName} button-name`}>{name}</div>
      <div className={`${themeClassName} button-container`}>
        {props.checkinCompletedActionUrl && (
          <button
            className={`${themeClassName} button action`}
            onClick={() => window.open(props.checkinCompletedActionUrl)}
          >
            Acción
          </button>
        )}
        <button
          className={`${themeClassName} button ${finished ? 'finished' : ''} ${
            props.disabled ? 'disabled' : ''
          }`}
        >
          {text}
        </button>
      </div>

      {themeStyle}
    </div>
  );
}
